import type { Receivable } from "@/types";
import { formatCOP, formatNumber } from "@/utils/format";
import { receivablePaid, receivableBalance } from "@/utils/accounting";

// Re-export para que otros paneles de Cartera sigan importando desde aquí.
export { receivablePaid, receivableBalance };

interface CarteraStatsProps {
  receivables: Receivable[];
}

const CarteraStats = ({ receivables }: CarteraStatsProps) => {
  const totalFiado = receivables.reduce((acc, r) => acc + r.initialValue, 0);
  const totalAbonado = receivables.reduce((acc, r) => acc + receivablePaid(r), 0);
  const saldo = receivables.reduce((acc, r) => acc + receivableBalance(r), 0);
  const pendientes = receivables.filter((r) => receivableBalance(r) > 0).length;

  const cards = [
    { icon: "ri-file-list-3-line", label: "Total fiado", value: formatCOP(totalFiado), bubble: "bg-primary-500/25 text-primary-100" },
    { icon: "ri-hand-coin-line", label: "Total abonado", value: formatCOP(totalAbonado), bubble: "bg-accent-500/20 text-accent-200" },
    { icon: "ri-hourglass-line", label: "Saldo por cobrar", value: formatCOP(saldo), bubble: "bg-secondary-500/25 text-secondary-200" },
    { icon: "ri-user-received-line", label: "Cuentas pendientes", value: formatNumber(pendientes), bubble: "bg-accent-500/15 text-accent-100" },
  ];

  return (
    <div className="grid grid-cols-2 xl:grid-cols-4 gap-3 md:gap-4">
      {cards.map((c) => (
        <div key={c.label} className="glass-panel rounded-lg p-4 animate-fade-up">
          <span className={`w-9 h-9 rounded-lg flex items-center justify-center ${c.bubble}`}>
            <i className={`${c.icon} text-lg`} />
          </span>
          <p className="text-[11px] text-foreground-500 mt-3">{c.label}</p>
          <p className="text-lg md:text-xl font-heading font-extrabold text-foreground-950 mt-0.5 break-words">
            {c.value}
          </p>
        </div>
      ))}
    </div>
  );
};

export default CarteraStats;